<template>
  <div class="md:mx-4 lg:mx-8 text-dark">
    <div class="text-center ">

      <div class="flex items-center justify-center">
        <img src="@/assets/images/ambassador.svg" alt="Image" class="mx-auto mb-4 w-2/3">
      </div>

      <h5 class="font-bold text-warning">Become an improvee.io affiliate</h5>

      <h1 class="text-5xl font-black text-black mt-4">earn passive income</h1>



      <div class="text-xl">Get paid to promote improvee.io and help other people to truly change and improve their lives.
      </div>

      <div class="text-left mt-8">

          <div class="mt-4">
            <h4 class="font-bold">1. join our program</h4>
            <p>Sign up for the improvee.io Affiliate Program to get your unique affiliate link.</p>


            <div class="flex justify-center my-2">
                <vs-button size="small" @click="openDashboard">
            Open Affiliate Dashboard
          </vs-button>
            </div>
            
          </div>


          <div class="mt-4">
            <h4 class="font-bold">2. share link</h4>
            <p>Promote your affiliate link. When people click your link, they will then have 60 days to sign up in order for you to receive commission.</p>
          </div>


          <div class="mt-4">
            <h4 class="font-bold">3. earn money!</h4>
            <p>Earn 30% commission & enjoy your passive income for 12 months.</p>
          </div>

      </div>
      


    <vs-collapse class="mt-8 px-0">

      <vs-collapse-item >
          <div slot="header" class="flex items-center text-sm">
            <feather-icon icon="ThumbsUpIcon" class="mr-1 w-4" />
            <span class="font-bold">Guidelines: DO</span>
          </div>

          <div class="text-left text-sm">
            <p class="mb-1 mr-1">• Share with your inner circle - tell friends and family who need to empower to make positive changes in their lives</p>
            <p class="mb-1 mr-1">• Place your affiliate link in blogs, comparisons, social media, etc.</p>
            <p class="mb-1 mr-1">• Promote improvee.io with your link on social media channels</p>
            <p class="mb-1 mr-1">• Publish educational content - get creative. Record tutorials, run webinars or even create courses</p>
            <p class="mb-1 mr-1">• Get your clients onboard - are you a mentor, coach or agency? or freelancer? Recommend improvee.io to your clients to earn more on top of your services</p>
          </div>
      </vs-collapse-item>

      <vs-collapse-item >
          <div slot="header" class="flex items-center text-sm">
            <feather-icon icon="ThumbsDownIcon" class="mr-1 w-4" />
            <span class="font-bold">Guidelines: DON'T</span>
          </div>

          <div class="text-left text-sm">
            <p class="mb-1 mr-1">• Use your affiliate link on sites with adult or illegal content.</p>
            <p class="mb-1 mr-1">• Use fraudulent marketing tactics.</p>
            <p class="mb-1 mr-1">• Abuse the program.</p>
          </div>
      </vs-collapse-item>


      <vs-collapse-item >
          <div slot="header" class="flex items-center text-sm">
            <feather-icon icon="HelpCircleIcon" class="mr-1 w-4" />
            <span class="font-bold">How long does the cookie last?</span>
          </div>

          <div class="text-left text-sm">
           Visitors have 60 days to sign up for improvee.io after clicking on your link.
          </div>
      </vs-collapse-item>

      <vs-collapse-item >
          <div slot="header" class="flex items-center text-sm">
            <feather-icon icon="HelpCircleIcon" class="mr-1 w-4" />
            <span class="font-bold">How often do you process rewards?</span>
          </div>

          <div class="text-left text-sm">
           Rewards are available 45 days after a referral begins paying.
          </div>
      </vs-collapse-item>

      <vs-collapse-item >
          <div slot="header" class="flex items-center text-sm">
            <feather-icon icon="HelpCircleIcon" class="mr-1 w-4" />
            <span class="font-bold">How do I get paid?</span>
          </div>

          <div class="text-left text-sm">
          Payments are verified and paid-out 45 days after your commission is earned. Your rewards are calculated and available for cash-out via PayPal or Stripe (alternative methods available for non-PayPal regions).
          </div>
      </vs-collapse-item>
    </vs-collapse>

    <h5 class="mt-2">Start earning cash for helping improvee.io grow.</h5>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
   return {
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    openDashboard () {
      window.open('https://improvee-io.getrewardful.com/signup', '_blank')
      this.$store.dispatch('ADDITIONAL_USER_INFO', { openedAffiliateDashboard: true })
    }
  }
}
</script>
